import { StyleSheet } from "react-native";
import { height, width } from "../../utils/utils";
export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#CCE4FF",
    flexDirection: "row",
  },
  viewDetail: {
    width: "90%",
    backgroundColor: "#FFFFFF",
    borderRadius: 50,
    borderWidth: 1,
    borderColor: "#707070",
    alignSelf: "center",
    marginVertical: 57,
  },
  textSubject: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginHorizontal: width * 0.05,
    marginTop: 50,
  },
  viewUpload: {
    flexDirection: "row",
    marginHorizontal: width * 0.045,
    marginTop: 20,
  },
  buttonUpload: {
    width: 110,
    height: 50,
    borderRadius: 9,
    backgroundColor: "#E6E6E6",
    justifyContent: "center",
  },
  textUpload: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#959595",
    alignSelf: "center",
  },
  textSelectPhoto: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#959595",
    marginLeft: 8,
    alignSelf: "center",
  },
  buttonSave: {
    width: 111,
    height: 53,
    backgroundColor: "#CCE4FF",
    borderRadius: 5,
    justifyContent: "center",
    marginHorizontal: width * 0.045,
    marginTop: 43.5,
    marginBottom: 85,
  },
  textSave: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    alignSelf: "center",
  },
  viewModal: {
    width: width,
    height: height,
    backgroundColor: "#000000bb",
  },
  viewSuccesModal: {
    width: width * 0.3,
    height: 100,
    backgroundColor: "#A7FFB2",
    borderWidth: 1,
    borderColor: "#36FF5E",
    justifyContent: "center",
    alignSelf: "center",
    marginTop: 20,
  },
  textSuccesModal: {
    fontSize: 28,
    fontFamily: "Prompt",
    color: "#2BB165",
    alignSelf: "center",
  },
});
export const stylesResponsive = StyleSheet.create({
  viewDetail: {
    width: "90%",
    backgroundColor: "#FFFFFF",
    borderRadius: 50,
    borderWidth: 1,
    borderColor: "#707070",
    alignSelf: "center",
    paddingHorizontal: 20,
    marginVertical: 20,
  },
  textSubject: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginHorizontal: width * 0.05,
    marginTop: 50,
  },
});
